const ProductCardSkeleton = () => {
  return (
    <div className="bg-white rounded-xl shadow-sm p-4 animate-pulse">
      {/* Image */}
      <div className="w-full h-48 bg-gray-200 rounded-lg mb-4" />

      {/* Title */}
      <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />

      {/* Subtitle */}
      <div className="h-3 bg-gray-200 rounded w-1/2 mb-4" />

      {/* Price */}
      <div className="h-4 bg-gray-300 rounded w-1/3 mb-4" />

      {/* Button */}
      <div className="h-10 bg-gray-200 rounded-lg w-full" />
    </div>
  );
};

export default ProductCardSkeleton;